var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('client-page', {
    scopedSlots: _vm._u([{
      key: "subHead",
      fn: function fn() {
        return [_c('sub-visual', {
          attrs: {
            "id": "rearing",
            "title": "솔루션",
            "src": "/images/sub/subvisual-solution.jpg"
          }
        })];
      },
      proxy: true
    }])
  }, [_c('page-section', {
    staticClass: "page-section--first",
    scopedSlots: _vm._u([{
      key: "titleLine",
      fn: function fn() {
        return [_vm._v(" 식물공장 시설 ")];
      },
      proxy: true
    }])
  }, [_c('tit-wrap-large', {
    staticClass: "mb-0",
    scopedSlots: _vm._u([{
      key: "text",
      fn: function fn() {
        return [_vm._v(" 작물재배환경의 기본이 되는 근권환경측정 제어장치 기술을 바탕으로 "), _c('br', {
          staticClass: "d-none d-lg-block"
        }), _vm._v("작물에 가장 적합한 양액을 공급하여 최상 상태의 작물을 수확하는 정밀농업이 가능해집니다. ")];
      },
      proxy: true
    }])
  }, [_vm._v(" 더욱 높은 품질의 농작물 생산을 "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v("가능하게 하는 "), _c('b', [_vm._v("양액재배 관리시스템")])])], 1), _c('page-section', {
    staticClass: "page-section--last grey lighten-5"
  }, [_c('page-section', {
    staticClass: "page-section--sm py-0",
    scopedSlots: _vm._u([{
      key: "pageSectionImmersive",
      fn: function fn() {
        return [_c('v-row', {
          staticClass: "mx-n20px my-n10px mx-md-n30px my-md-n20px"
        }, [_c('v-col', {
          staticClass: "px-20px py-10px px-md-30px py-md-20px",
          attrs: {
            "cols": "12",
            "md": "6",
            "data-aos": "fade-left",
            "data-aos-delay": "200"
          }
        }, [_c('v-card', {
          attrs: {
            "outlined": "",
            "rounded": ""
          }
        }, [_c('v-img', {
          staticClass: "mx-auto",
          attrs: {
            "max-width": "570",
            "aspect-ratio": 570 / 456,
            "src": "/images/sub/solution/plant/rearing-img.jpg"
          }
        })], 1)], 1), _c('v-col', {
          staticClass: "px-20px py-10px px-md-30px py-md-20px",
          attrs: {
            "cols": "12",
            "md": "6",
            "data-aos": "fade-right",
            "data-aos-delay": "200"
          }
        }, [_c('div', {
          staticClass: "mt-md-24px"
        }, [_c('tit-wrap-sprout', {
          scopedSlots: _vm._u([{
            key: "text",
            fn: function fn() {
              return [_vm._v(" 시설재배 작물 생장환경 실시간 모니터링 장비 ")];
            },
            proxy: true
          }])
        }, [_vm._v(" 식물공장 재배대 시스템 ")]), _c('txt-item', {
          scopedSlots: _vm._u([{
            key: "title",
            fn: function fn() {
              return [_vm._v("구성")];
            },
            proxy: true
          }])
        }, [_vm._v(" 급액 감지부, 배액 감지부, 무게 감지부, 양액 공급부, 디스플레이, 컨트롤유닛, 경고부 ")]), _c('div', {
          staticClass: "mt-16px mt-md-24px"
        }, [_c('v-img', {
          staticClass: "mx-auto",
          attrs: {
            "max-width": "570",
            "aspect-ratio": 570 / 158,
            "src": "/images/sub/solution/plant/rearing-img2.png"
          }
        })], 1)], 1)])], 1)];
      },
      proxy: true
    }])
  }), _c('page-section', {
    staticClass: "page-section--sm pb-0",
    scopedSlots: _vm._u([{
      key: "pageSectionImmersive",
      fn: function fn() {
        return [_c('v-card', {
          attrs: {
            "outlined": "",
            "rounded": "",
            "data-aos": "fade",
            "data-aos-delay": "100"
          }
        }, [_c('v-responsive', {
          attrs: {
            "aspect-ratio": 1200 / 770,
            "content-class": "d-flex align-center justify-center"
          }
        }, [_c('div', {
          staticClass: "pa-30px pa-md-40px px-lg-80px"
        }, [_c('v-img', {
          staticClass: "mx-auto",
          attrs: {
            "max-width": "696",
            "aspect-ratio": 696 / 474,
            "src": "/images/sub/solution/plant/rearing-img3.jpg"
          }
        }), _c('div', {
          staticClass: "pt-30px pt-md-40px pt-lg-60px"
        }, [_c('tit-wrap-small', {
          scopedSlots: _vm._u([{
            key: "text",
            fn: function fn() {
              return [_vm._v(" 재배 시스템에 여러 사항들에 대한 수치를 입력해 놓으면, 미리 설정된 임계값 범위에서 벗어날 때 "), _c('br', {
                staticClass: "d-none d-lg-block"
              }), _vm._v("경고부를 통해 위험 요소를 사전에 전달하여 가장 효율적인 재배가 가능하도록 합니다. ")];
            },
            proxy: true
          }])
        })], 1)], 1)])], 1)];
      },
      proxy: true
    }])
  }), _c('page-section', {
    staticClass: "page-section--sm pb-0",
    scopedSlots: _vm._u([{
      key: "pageSectionImmersive",
      fn: function fn() {
        return [_c('v-row', {
          attrs: {
            "justify": "center"
          }
        }, [_c('v-col', {
          attrs: {
            "cols": "12",
            "md": "6",
            "lg": "4",
            "data-aos": "fade",
            "data-aos-delay": "100"
          }
        }, [_c('v-card', {
          attrs: {
            "outlined": "",
            "rounded": ""
          }
        }, [_c('v-img', {
          staticClass: "ma-auto",
          attrs: {
            "max-width": "382",
            "aspect-ratio": 382 / 540,
            "src": "/images/sub/solution/plant/rearing-img4.jpg"
          }
        })], 1), _c('tit-wrap-small', {
          staticClass: "mt-14px mt-md-20px",
          attrs: {
            "mbSmall": ""
          },
          scopedSlots: _vm._u([{
            key: "text",
            fn: function fn() {
              return [_vm._v(" 양액재배 관리장치 ")];
            },
            proxy: true
          }])
        }, [_vm._v(" 특허등록 ")])], 1)], 1)];
      },
      proxy: true
    }])
  })], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }